import { render, staticRenderFns } from "./ViewPurchaseOrder.vue?vue&type=template&id=98eef73e&"
import script from "./ViewPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./ViewPurchaseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports